<template>
  <div class="break">
    <div class="break__wrapper">
      <ul class="break__list">
        <li v-for="breakItem in breaks" class='break__list-option' :key="breakItem.id" @click="selectBreak(breakItem)">
          <input type="radio" :value="breakItem.id" v-model="value" :key="breakItem.id" />
          <label :for="breakItem.name">
            <span>{{ breakItem.name }}</span>
          </label>
        </li>
      </ul>
      <div class="break__buttons">
        <el-button type="default" @click="$emit('cancel')">Cancelar</el-button>
        <el-button type="primary" @click="setBreak">Aceptar</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'TheBreak',
  data() {
    return {
      breaks: [],
      breakSelected: null,
      value: 0
    }
  },
  methods: {
    ...mapActions([
      'fetchBreaks',
      "doBreak"
    ]),
    setBreak(){
      console.log(this.breakSelected)
      this.doBreak(this.breakSelected)
      this.$emit('break-selected')
    },
    selectBreak(_break){
      console.log(_break)
      this.value = _break.id
      this.breakSelected = _break
    }
  },
  computed: {
    ...mapGetters({
      getBreaks: 'getBreaks'
    })
  },
  async created() {
    this.breaks = this.getBreaks
    console.log(this.breaks)
  }
}
</script>
<style scoped>
.break {
  height: 100%;
}
.break__wrapper{
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.break__list{
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 90px);
  overflow-y: auto;
  height: 100%;
  gap: 5px;
  width: 100%;

}
.break__list .break__list-option{
  padding: 10px;
  border: 1px solid #ccc;
  cursor: pointer;
  display: flex;
  gap: 5px;
}
.break__buttons{
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
}
.break__wrapper button{
  width: 100%;
  margin: 0 !important;
}
</style>